/**
 * Componente Logo
 * Muestra el logotipo de Intercasa con enlace a la página principal.
 * El texto alternativo se traduce (`common.json`, clave `logo.alt`).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LocalizedLink from './LocalizedLink';

/**
 * Logo de Intercasa
 * @param {Object} props - Propiedades del componente
 * @param {string} props.className - Clases CSS adicionales (incluye filtros para modo claro/oscuro)
 * @param {boolean} props.footer - Si el logo se usa en el footer (afecta el tamaño)
 * @param {boolean} props.withLink - Si el logo debe incluir enlace a inicio
 * @returns {JSX.Element} Componente de logo
 */
const Logo = ({ className = '', footer = false, withLink = false }) => {
  const { t } = useTranslation();
  const sizeClasses = footer ? 'h-12 w-auto' : 'h-16 w-auto';

  const logoImage = (
    <img 
      src="/images/recipes/2-PEQ.webp" 
      alt={t('logo.alt')} 
      className={`${sizeClasses} ${className}`}
    />
  );

  // Si withLink es false, retornar solo la imagen (útil cuando el Link está en el padre)
  if (!withLink) {
    return logoImage;
  }

  return (
    <LocalizedLink to="/" className="inline-block">
      {logoImage}
    </LocalizedLink>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  footer: PropTypes.bool,
  withLink: PropTypes.bool,
};

export default Logo;
